import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import { Modal } from '@/components/Modal/Modal';
import { useShoppingCartRoute } from '@/services/feature-toggles-service';

interface IAddToCartModal {
  onHideModal: () => void;
  productCount: number;
  showModal: boolean;
}

export const AddToCartModal = ({ onHideModal, productCount, showModal, ...restProps }: IAddToCartModal & RestProps) => {
  const { t } = useTranslation('common');

  const modalButtons = [
    {
      variant: 'outline-primary',
      label: t('common:button.close'),
      onClick: onHideModal,
      className: 'btn-fixed mr-3'
    },
    {
      variant: 'primary',
      label: t('common:button.to-shoppingcart'),
      href: useShoppingCartRoute(),
      className: 'btn-fixed mr-3'
    }
  ];

  return (
    <>
      {showModal && (
        <Modal
          showModal={showModal}
          onCloseModal={onHideModal}
          buttons={modalButtons}
          title={t('modal.add-to-cart.confirmed-added-to-basket')}
          BodyComponent={
            <>
              <span className="text-muted">{t('modal.add-to-cart.product-count', { count: productCount })}</span>
            </>
          }
          {...restProps}
        />
      )}
    </>
  );
};
